import { render } from "./AdminAdditions.component.vue?vue&type=template&id=c75b953c"
import script from "./AdminAdditions.component.vue?vue&type=script&lang=js"
export * from "./AdminAdditions.component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__